module.exports = __webpack_public_path__ + "school/img/geren.4bc225bd.jpg";